import _uniq from 'lodash/uniq';

import { formatDate, toggleSelected } from '../../../core/helpers/default';
import {
  GET_PETITIONS_REQUEST,
  GET_PETITIONS_SUCCESS,
  GET_PETITIONS_FAILED,
  PRINT_PETITIONS_REQUEST,
  PRINT_PETITIONS_SUCCESS,
  PRINT_PETITIONS_FAILED,
  SET_SELECTED_PETITION,
  FORCE_FETCH,
  UPDATE_PETITION_PHOTO,
  TOGGLE_ALL_ROWS,
  TOGGLE_ROWS_BULK,
  ASSIGN_LABELS_REQUEST,
  ASSIGN_LABELS_SUCCESS,
  ASSIGN_LABELS_FAILED,
  TOGGLE_CANONICAL_SCAN_LOCK_REQUEST,
  TOGGLE_CANONICAL_SCAN_LOCK_SUCCESS,
  TOGGLE_CANONICAL_SCAN_LOCK_FAILED,
  FLAG_AS_DUPLICATE_SCAN_REQUEST,
  FLAG_AS_DUPLICATE_SCAN_SUCCESS,
  FLAG_AS_DUPLICATE_SCAN_FAILED,
  COVER_PAGE_ONLY_TOGGLE,
} from './actionTypes';

const initialState = {
  data: [],
  dataMap: new Map([]),
  meta: {
    page: 1,
    lastPage: null,
    perPage: 50,
    sort: null,
    order: null,
    search: '',
  },
  loading: false,
  error: null,
  petitionsIds: [],
  forceFetch: false,
  coverPageOnly: false,
};

const createMap = (array, key) => {
  const map = new Map();
  array.forEach((item) => map.set(item[key], item));
  return map;
};

const petitionsTableReducer = (
  state = initialState,
  {
    type, error, data, meta, petitionId, selectAll, updatedPetition, bulkMeta,
  },
) => {
  switch (type) {
    case GET_PETITIONS_REQUEST:
      return { ...state, loading: true };
    case GET_PETITIONS_SUCCESS:
      return {
        ...state,
        data: data.map((i) => ({
          ...i,
          _selected: false,
          date_generated: i.date_generated ? formatDate(i.date_generated) : '',
          updated_at: i.updated_at ? formatDate(i.updated_at) : '',
        })),
        dataMap: createMap(data, 'id'),
        meta: {
          search: meta.search,
          page: meta.page,
          lastPage: meta.last_page,
          order: meta.order,
          sort: meta.sort,
          perPage: meta.per_page,
        },
        total: meta.total,
        from: meta.from,
        to: meta.to,
        loading: false,
        forceFetch: false,
        petitionsIds: [],
        coverPageOnly: false,
      };
    case GET_PETITIONS_FAILED:
      return { ...state, loading: false };
    case PRINT_PETITIONS_REQUEST:
      return { ...state, loading: true };
    case PRINT_PETITIONS_SUCCESS:
      return { ...state, loading: false, coverPageOnly: false };
    case PRINT_PETITIONS_FAILED:
      return { ...state, loading: false, error };
    case ASSIGN_LABELS_REQUEST:
      return { ...state, loading: true };
    case ASSIGN_LABELS_SUCCESS:
      return { ...state, loading: false, forceFetch: true };
    case ASSIGN_LABELS_FAILED:
      return { ...state, loading: false, error };
    case TOGGLE_CANONICAL_SCAN_LOCK_REQUEST:
      return { ...state, loading: true };
    case TOGGLE_CANONICAL_SCAN_LOCK_SUCCESS:
      return { ...state, loading: false, forceFetch: true };
    case TOGGLE_CANONICAL_SCAN_LOCK_FAILED:
      return { ...state, loading: false, error };
    case FLAG_AS_DUPLICATE_SCAN_REQUEST:
      return { ...state, loading: true };
    case FLAG_AS_DUPLICATE_SCAN_SUCCESS:
      return { ...state, loading: false, forceFetch: true };
    case FLAG_AS_DUPLICATE_SCAN_FAILED:
      return { ...state, loading: false, error };
    case FORCE_FETCH:
      return {
        ...state,
        loading: false,
        forceFetch: true,
        petitionsIds: [],
      };
    case UPDATE_PETITION_PHOTO:
      // eslint-disable-next-line max-len,no-case-declarations
      const tempData = state.data.map((i) => (updatedPetition.id === i.id ? { ...i, photos: updatedPetition.photos } : i));
      return {
        ...state,
        data: tempData,
        dataMap: createMap(tempData, 'id'),
      };
    case SET_SELECTED_PETITION:
      return {
        ...state,
        petitionsIds: toggleSelected(state.petitionsIds, petitionId),
        data: state.data.map((i) => (petitionId === i.id ? { ...i, _selected: !i._selected } : i)),
      };
    case TOGGLE_ALL_ROWS:
      return {
        ...state,
        petitionsIds: selectAll ? state.data.map(({ id }) => id) : [],
        data: state.data.map((i) => ({ ...i, _selected: selectAll })),
      };
    case TOGGLE_ROWS_BULK:
      // eslint-disable-next-line no-case-declarations
      const { prev, next } = bulkMeta;
      if (prev) {
        const petitionsIdsToCheck = [];
        let tempDataForBulkOperation = [];
        const prevIndex = state.data.findIndex((el) => el.id === prev);
        const nextIndex = state.data.findIndex((el) => el.id === next);
        state.data.forEach((el, key) => {
          if (key >= prevIndex && key <= nextIndex) {
            petitionsIdsToCheck.push(el.id);
            tempDataForBulkOperation = [...tempDataForBulkOperation, { ...el, _selected: true }];
          } else {
            tempDataForBulkOperation = [...tempDataForBulkOperation, el];
          }
        });
        return {
          ...state,
          petitionsIds: _uniq([...state.petitionsIds, ...petitionsIdsToCheck]),
          data: tempDataForBulkOperation,
        };
      }
      return state;
    case COVER_PAGE_ONLY_TOGGLE:
      return {
        ...state,
        coverPageOnly: !state.coverPageOnly,
      };
    default:
      return state;
  }
};

export default petitionsTableReducer;
